import React from 'react'
import { useMappingStats } from '../../../../../features/groupCustomerMapping/queries/useMappingStats'
import { useMappingCompanies } from '../../../../../features/groupCustomerMapping/queries/useMappingCompanies'
import { useGroupSourceMaps } from '../../../../../features/groupCustomerMapping/queries/useGroupSourceMaps'
import CustomerMappingMatrix from '../../../../../features/groupCustomerMapping/components/CustomerMappingMatrix'
import Loading from '../../../../../shared/components/Loading'
import RequestError from '../../../../../shared/components/RequestError'

const CustomerMapping: React.FC = () => {
  const { rows, stats, companies, isCompaniesLoading, isSourceMapsLoading, isError } = useMappingStats()
  const { refetch: refetchCompanies } = useMappingCompanies()
  const { refetch: refetchSourceMaps } = useGroupSourceMaps(companies.map(company => company.id))

  if (isCompaniesLoading) return <Loading />
  if (isError) return <RequestError error="" refetch={() => Promise.all([refetchCompanies(), refetchSourceMaps()])} />

  return <CustomerMappingMatrix rows={rows} stats={stats} loading={isSourceMapsLoading} />
}

export default CustomerMapping
